import { sendToApi } from 'api/client'

export interface PromotionCode {
  expires_at: number
  id: string
  coupon: {
    id: string
    name: string
    amount_off: number | null
    percent_off: number | null
    duration: string | null
    duration_in_months: number | null
  }
}

export const StripePromotionCodeClient = {
  get: async (promoCode: string) => {
    return sendToApi<{ promotion_code?: PromotionCode }>(`/stripe/promotion_codes/${promoCode}`, { method: 'GET' })
  },
}
